import { render, staticRenderFns } from "./NenhumTerceiroInformado.vue?vue&type=template&id=1b4b427f&scoped=true"
import script from "./NenhumTerceiroInformado.vue?vue&type=script&lang=js"
export * from "./NenhumTerceiroInformado.vue?vue&type=script&lang=js"
import style0 from "./NenhumTerceiroInformado.vue?vue&type=style&index=0&id=1b4b427f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4b427f",
  null
  
)

export default component.exports